angular.module('property-price-list')
    .controller('PropertyPriceListStatusChangeController', function ($uibModalInstance, $rootScope, $state, toastr, data, PropertyPriceList) {
        this.propertyPriceList = data.propertyPriceList;
        this.form = {
            id: data.propertyPriceList.id,
            status: data.status,
            action: data.action
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return PropertyPriceList.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-price-list.updated', result);
                toastr.success("Zapisano poprawnie nowe ceny", "Zapisano");
                $uibModalInstance.close(result);
            })
        }
    })
